/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useContext, useState, useRef} from 'react';
import { FuelPrices } from 'components/FuelPrices/FuelPrices';
import {NewAgreements} from '../components/NewAgreements/NewAgreements';
import {NewInvoices} from '../components/NewInvoices/NewInvoices';
import { AuthenticationContext } from '../services/context/authentication.context';
import { LoyaltyCard } from 'components/LoyaltyCard/LoyaltyCard';
import { NewInvoicesPaid } from 'components/NewInvoices/NewInvoicesPaid/NewInvoicesPaid';
import LoyaltyService from 'services/loyalty.service';
import { LoyaltyLevel } from 'models/loyalty';
import { Spinner } from 'react-bootstrap';


import cloudicsLogo from '../assets/gfx/cloudics_logo.png';
import { DashboardIdCredit } from 'components/CustomerCards/frontpage/DashboardIdCredit';
import { PageProps } from 'models/page';
import DashboardConsumption from 'components/Dashboard/DashboardConsumption';
import { toast } from 'react-toastify';
import CustomerCardService from 'services/customer-card.service';
import { ICustomerCardType } from 'models/customer-card';
import { mapUserContactToCustomer } from 'services/user.service';
import CustomerContactService from 'services/customer-contact.service';

const COFFEE_POINTS_NEEDED = 4;

const CUSTOMER_CONTACT_SYNC_INTERVAL_MILLIS = 120_000; // 2 minutes

export function Frontpage(props: PageProps) {
    const [loyaltyLevels, setLoyaltyLevels] = useState<LoyaltyLevel[]>([]);
    const { state, dispatch } = useContext(AuthenticationContext);

    const lastCustomerIdRef = useRef<string | null>(null);

    useEffect(() => {
        props.onLoadValidatePage();
        if(state.authenticated){
            LoyaltyService.getLoyaltyLevels().then(res => setLoyaltyLevels(res));
        }
    }, [state.authenticated]);

    useEffect(() => {
        if(!state.customer || !state.customerId) return;
        showCardNotification(state.customerId)
    }, [state.customer, state.showCardNotification]);

    // Sync current contact person periodically
    useEffect(() => {
        const contactId = state.customer?.contactId;
        if (!contactId) return;

        if (lastCustomerIdRef.current === contactId) return;

        lastCustomerIdRef.current = contactId;

        let intervalId: NodeJS.Timeout;

        const fetchAndDispatch = async () => {
            try {
                const res = await CustomerContactService.getCurrentUserContactWithSync(
                    state.userId,
                    contactId
                );

                dispatch({
                    type: 'setCustomer',
                    value: mapUserContactToCustomer(res)
                });
                
            } catch (err) {
                console.error('Error fetching user contact:', err);
            }
        };

        fetchAndDispatch();

        intervalId = setInterval(fetchAndDispatch, CUSTOMER_CONTACT_SYNC_INTERVAL_MILLIS);

        return () => clearInterval(intervalId);

    }, [state.userId, state.customer?.contactId]);

    const showCardNotification = async (customerId: number) => {
        if(!state.showCardNotification) return;

        try{
            const res = await CustomerCardService.getCustomerCards(customerId, ICustomerCardType.PAYMENT_CARD, {
                page: 0,
                size: 9000,
                isBlockedCard: false
            });
            const cards = res.content;
            
            if(!cards.length) return;
            if(cards.every(card => !!card.monthlyLimit)) return;

            toast.warning("Sul on määramata kaardipõhised limiidid");

            dispatch({
                type: "setShowCardNotification",
                value: false
            });
        }catch(e){
            console.error(e);
        }
    }

    if (!state.authenticated) {
        return null;
    }

    const monthQuantity = state.customer?.cardLoyalty?.monthQuantity || 0;
    const coffeePoints = state.customer?.cardLoyalty?.coffeePoints || 0;
    const runningCoffeeCount = coffeePoints % COFFEE_POINTS_NEEDED;
    const coffeesToClaim = Math.floor(coffeePoints / COFFEE_POINTS_NEEDED) || 0;
    const levelId = state.customer?.cardLoyalty?.levelId || state.customer?.groupId;
    const isPrivilegedGroup = levelId?.indexOf('IDC') === -1;

    const currentDiscount = getLevelDiscount(loyaltyLevels, levelId);
    const level1Discount = getLevelDiscount(loyaltyLevels, 'IDC');
    const level2Discount = getLevelDiscount(loyaltyLevels, 'IDC2');

    const discountDiff = Math.abs(level2Discount || 0) - Math.abs(level1Discount || 0);

    const date = new Date();

    if (!state.customer) {
        return <Spinner animation="grow" variant="primary" />
    }
    const userAgent = window.navigator.userAgent.toLowerCase();
    const ios = /iphone|ipod|ipad/.test(userAgent);
    const android = /android/.test(userAgent);
    const webview = /wv/.test(userAgent);

    const showCloudics = ios || android;

    const openAppAndroid = () => {
        window.location.href = 'com.cloudicsapp://';
        const timeout = setTimeout(() => window.location.href = 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.cloudicsapp', 1500);

        if (!webview) {
            window.onblur = () => {
                console.log('on blur');
                clearTimeout(timeout);
            }
        }
    }

    return (
        <>
            <div className="frontpage__container">
            { state.customer?.isPerson && <div className='frontpage__container--left loyalty-card__wrap'>
                { showCloudics && <div className='d-flex d-md-none align-items-center justify-content-center mb-3 mt-n3'>
                        {ios ?
                        <a className='btn btn-cloudics' href='https://apps.apple.com/ee/app/cloudics/id1486293359' target='_blank' rel='noopener noreferrer'>
                            <img src={cloudicsLogo} alt='Cloudics' />
                            <div className='d-flex align-items-center'>
                                <span>Tangi äpiga</span>
                                <i className="icon icon__redirect"></i>
                            </div>
                        </a> :
                        <button className='btn btn-cloudics' onClick={openAppAndroid}>
                            <img src={cloudicsLogo} alt='Cloudics' />
                            <div className='d-flex align-items-center'>
                                <span>Tangi äpiga</span>
                                <i className="icon icon__redirect ml-2"></i>
                            </div>
                        </button>}
                    </div> }
                    <h2 className='u-fs-20 mb-3'>SOODUSTUSED</h2>
                    <DashboardIdCredit />
                    <LoyaltyCard
                        size="large"
                        type="fuel"
                        fuelCapacity={monthQuantity}
                        isPrivilegedGroup={isPrivilegedGroup}
                        levelId={levelId}
                        currentDiscount={currentDiscount}
                        fuelDiscount={discountDiff}
                    />
                    <div className='loyalty-card__wrap--small'>
                        <LoyaltyCard
                            size="small"
                            type="coffee"
                            smallAlertDescription={ coffeesToClaim > 0 && date.getMonth() === 0 ? 'Tasuta kohvisid saab lunastada jaanuari lõpuni' : ''}
                            smallSuccessTitle={ coffeesToClaim > 0 ? 'Tasuta kohvide arv' : 'Iga <strong>5.</strong> kohv tasuta!'}
                            freeSum={coffeesToClaim}
                            collectedSum={runningCoffeeCount}
                            maxSum={COFFEE_POINTS_NEEDED}
                        />
                        {/* <LoyaltyCard size="small" type="hamburger" smallSuccessTitle="Tasuta kohvide arv"/> */}
                        <LoyaltyCard size="small" type="carwash" smallSuccessTitle="Autopesu" freeSum="-10%"/>
                    </div>
                </div>
            }
                <div className='frontpage__container--top'>
                    <NewInvoicesPaid/>
                    <NewAgreements/>
                    <NewInvoices history={props.history}/>
                </div>
                <div className='frontpage__container--right-up'>
                    <DashboardConsumption />
                </div>
                {state.customer && !state.customer.isPerson ?
                    <div className={state.customer.isPerson ? 'frontpage__container--right-down' : 'frontpage__container--left'}>
                        <FuelPrices/>
                    </div> : null}
            </div>
        </>
    )
}


const getLevelDiscount = (levels: LoyaltyLevel[], levelId: string): number | undefined => {
    return levels.find(l => l.id === levelId)?.discount || 0;
}